<!-- 平台查看多控销售统计 --  报表 -->
<template>
  <div class="pl-sales-statistic-table">
    <div class="pl-sales-statistic-search-form">
      <el-form
        :inline="true"
        :model="searchForm"
        class="pl-sales-statistic-form"
      >
        <!-- 搜索店铺名称 -->
        <el-form-item label="">
          <el-input
            v-model.trim="searchForm.shopName"
            placeholder="搜索店铺名称"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 搜索商品 -->
        <el-form-item label="">
          <el-input
            v-model.trim="searchForm.goodsName"
            placeholder="搜索商品"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="getList(1)" size="small"
            >查询</el-button
          >
          <el-button type="default" @click="resetForm()" size="small"
            >重置</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="handleAdd" size="small"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <myTable
      :selection="false"
      :page="page"
      :showpage="true"
      v-loading="isLoading"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
    >
      <template slot="state" slot-scope="scope">
        <span>{{ stateMap[scope.row.state] }}</span>
      </template>
      <template slot="operation" slot-scope="scope">
        <el-button
          type="text"
          size="mini"
          @click="handleDelete(scope.$index)"
          v-if="scope.row.state === 0"
          >删除</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleRemove(scope.$index)"
          v-if="scope.row.state === 0"
          >移除</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleMove(scope.$index)"
          v-if="scope.row.state === 1"
          >移入</el-button
        >
      </template>
    </myTable>
    <voucher-goods-add-dlg ref="voucherGoodsAddDlgRef" @fresh="getList(1)">
    </voucher-goods-add-dlg>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import voucherGoodsAddDlg from "./component/voucherGoodsAddDlg.vue";
import {
  getVoucherGoodsSkuPage,
  voucherGoodsSkuDelete,
  voucherGoodsSkuEdit,
} from "@/api/voucher";
export default {
  name: "PlSalesStatisticTable",
  components: {
    myTable,
    voucherGoodsAddDlg,
  },
  data() {
    return {
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [
        { label: "店铺名称", prop: "shopName" },
        { label: "商品", prop: "goodsName" },
        { label: "已补贴数量", prop: "alreadySubsidyQty", width: 150 },
        { label: "已补贴金额", prop: "alreadySubsidyAmount", width: 150 },
        { label: "状态", prop: "state", width: 150, slot: true },
        { label: "更新人", prop: "updateBy", width: 150 },
        { label: "更新时间", prop: "updateTime", width: 100 },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 100,
        },
      ],
      isLoading: false, //loading
      pendParams: null,
      searchForm: {
        shopName: "",
        goodsName: "",
      },
      voucherId: null, // 代金券id
      voucherName: "", // 代金券名称
      stateMap: {
        0: "活动中",
        1: "已移除",
      },
    };
  },
  created() {
    this.voucherId = this.$route.query?.voucherId || "";
    this.voucherName = this.$route.query?.voucherName || "";
    this.getList(1);
  },
  methods: {
    handleAdd() {
      this.$refs.voucherGoodsAddDlgRef.publicOpen(this.voucherId);
    },
    // 删除
    handleDelete(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将从“${this.voucherName}”活动中删除此商品，是否确认？`,
        "删除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }
      )
        .then(() => {
          voucherGoodsSkuDelete(row.id)
            .then((res) => {
              this.$message.success("删除成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 移除
    handleRemove(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将从“${this.voucherName}”活动中移除此商品，是否确认？`,
        "移除",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }
      )
        .then(() => {
          let obj = {
            id: row.id,
            state: 1,
          };
          voucherGoodsSkuEdit(obj)
            .then((res) => {
              this.$message.success("移除成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("移除失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    // 移入
    handleMove(index) {
      const row = this.tableData[index];
      this.$alert(
        `您将重新添加此商品至“${this.voucherName}”活动中，是否确认？`,
        "移入",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: true,
          type: "warning",
        }
      )
        .then(() => {
          let obj = {
            id: row.id,
            state: 0,
          };
          voucherGoodsSkuEdit(obj)
            .then((res) => {
              this.$message.success("移入成功");
              this.getList();
            })
            .catch((err) => {
              this.$message.error("移入失败");
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },
    getList(pageCurrent) {
      if (!this.voucherId) return;
      if (pageCurrent) {
        this.page.current = pageCurrent;
      }
      this.isLoading = true;
      let params = {
        current: this.page.current,
        size: this.page.size,
        voucherId: this.voucherId,
      };
      params = Object.assign(params, this.searchForm);
      getVoucherGoodsSkuPage(params)
        .then((res) => {
          this.tableData = res.records || [];
          this.page.total = res.total || 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.searchForm = {
        shopName: "",
        goodsName: "",
      };
      this.getList(1);
    },
  },
};
</script>

<style scoped lang="scss">
.pl-sales-statistic-table {
  background-color: #fff;
  height: 100%;
  padding: 10px;
}
::v-deep.zt__table {
  .el-table {
    height: calc(100% - 110px) !important;
    position: relative;
  }
}
</style>
